// extracted by mini-css-extract-plugin
module.exports = {"ProfileInfo":"profile-info_ProfileInfo__1MYOJ"};